import { createFromIconfontCN } from "@ant-design/icons";
import { AliIconfontUrl } from "../../../config/iconfontConfig";

const YsIcon = createFromIconfontCN({
  scriptUrl: AliIconfontUrl, // 在 iconfont.cn 上生成
});

export default YsIcon;
